<template>
    <div class="evento-plantas-view container-fluid mt-4">
      <!-- Botonera superior -->
      <div class="btn-group w-100 mb-3">
        <button
          class="btn btn-outline-primary flex-grow-1"
          :class="{ active: activeTab === 'listar' }"
          @click="activeTab = 'listar'"
        >
          Listar Plantas del Evento
        </button>
        <button
          class="btn btn-outline-primary flex-grow-1"
          :class="{ active: activeTab === 'mover' }"
          @click="activeTab = 'mover'"
        >
          Mover Plantas a Este Evento
        </button>
      </div>
      
      <!-- Componente dinámico -->
      <component :is="activeComponent" :proyecto_evento_id="proyecto_evento_id" :proyecto_id="proyecto_id"/>
    </div>
  </template>
  
  <script>
  import ListarPlantasEvento from '@/components/PlantaEvento/listarPlantaEvento.vue';
  import MoverPlantasEvento from '@/components/PlantaEvento/MoverPlantasEvento.vue';

  
  export default {
    name: 'EventoPlantasView',
    components: {
      ListarPlantasEvento,
      MoverPlantasEvento,
    },
    props: {
      proyecto_id: {
        type: Number,
        required: true,
      },
      proyecto_evento_id: {
        type: Number,
        required: true,
      },
    },
    data() {
      return {
        activeTab: 'listar', // Por defecto se muestra "Listar"
      };
    },
    computed: {
      activeComponent() {
        if (this.activeTab === 'listar') return 'ListarPlantasEvento';
        if (this.activeTab === 'mover') return 'MoverPlantasEvento';
        return null;
      },
    },
  };
  </script>
  
  <style scoped>
  .evento-plantas-view {
    padding: 15px;
    background-color: #f7f8fa;
  }
  
  .btn-group .btn {
    /* Asegura que los botones se adapten y se vean consistentes */
    font-size: 0.9rem;
    padding: 8px;
  }
  .btn-group .btn.active {
    background-color: var(--app-primary);
    color: #fff;
    border-color: var(--app-primary);
  }
  </style>
  